import { goodDog, goodCat } from '@/shared/assets'

export function usePolicyCard(pet?: { type?: string }) {
  const petIcon = pet?.type?.toLowerCase() === 'dog' ? goodDog : goodCat
  return { petIcon }
}
